module.exports = __webpack_public_path__ + "static/media/zl_2_11.9ef66698.png";